import { apiHelpers } from '../utils/api';
import type { CustomerFormData, CustomerStats, CustomerFilters, GetCustomersResponse, Customer } from '../types/customer';

export const customerService = {
  // Get customers with pagination and filters
  getCustomers: async (filters?: CustomerFilters): Promise<GetCustomersResponse> => {
    const params = new URLSearchParams();
    
    if (filters?.search) params.append('search', filters.search);
    if (filters?.status) params.append('status', filters.status);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.limit) params.append('limit', filters.limit.toString());

    return await apiHelpers.get(`/customers?${params.toString()}`);
  },

  // Get single customer by ID
  getCustomer: async (id: string): Promise<Customer> => {
    return await apiHelpers.get(`/customers/${id}`);
  },

  // Create new customer
  createCustomer: async (data: CustomerFormData): Promise<Customer> => {
    return await apiHelpers.post('/customers', data);
  },

  // Update customer
  updateCustomer: async (id: string, data: Partial<CustomerFormData & { status: string }>): Promise<Customer> => {
    return await apiHelpers.put(`/customers/${id}`, data);
  },

  // Delete customer
  deleteCustomer: async (id: string): Promise<void> => {
    return await apiHelpers.delete(`/customers/${id}`);
  },

  // Get customer statistics
  getCustomerStats: async (): Promise<CustomerStats> => {
    return await apiHelpers.get('/customers/stats');
  }
};